import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/file_money.svg'


const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-header mb-0" }, "Frequencia")
], -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "d-flex align-items-center justify-content-between py-4 border-bottom" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph mb-0" }, "Período", -1)
const _hoisted_6 = { class: "text-subtitle mb-0" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex align-items-center justify-content-between py-4 border-bottom"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph mb-0" }, "Próxima sessão", -1)
const _hoisted_9 = { class: "text-subtitle mb-0" }
const _hoisted_10 = { class: "d-flex align-items-center justify-content-between py-4" }
const _hoisted_11 = { class: "text-paragraph mb-0" }
const _hoisted_12 = { class: "text-subtitle" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "rounded-4 border p-4 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "me-4"
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph mb-0" }, " Os pagamentos futuros serão efetuados 72h antes de começar a sessões. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TimezoneAlert = _resolveComponent("TimezoneAlert")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.recurrency.frequencyLabel), 1)
        ]),
        (_ctx.recurrency?.nextAppointmentDate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.recurrency.nextAppointmentDate), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("p", _hoisted_11, [
            _createTextVNode(" Está sendo reservado sessões "),
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.recurrency?.frequencyText), 1),
            _createVNode(_component_TimezoneAlert, { class: "ms-2" })
          ])
        ]),
        _hoisted_13
      ])
    ])
  ]))
}